<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('payment.archive_payment')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="partners.find(p => p.id === partner_id) || ''"
              :options="partners"
              label="name"
              :placeholder="translations('payment.supplier')"
              id="partner_id"
              @input="changedPartner">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{translations('common.period')}}</span>
<!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus='tempDateField = dateFrom'>-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus='tempDateField = dateTo'>-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group mr-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-group" style="margin: 1px 0 0 0">
          <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{ translations('common.csv_export') }}</button>
        </div>
<!--         <div class="form-group">
          <button class="btn btn-sm btn-link p-0 decoration-underline" type="button" data-toggle="modal" data-target="#ArchivePurchasePaymentsModal">一括出金</button>
        </div> -->
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1300 table-clickable"
          item-key="name"
          :search="dtSearch"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: this.translations('purchase.name'), value: 'name' },
            { text: this.translations('purchase.client_order_number'), value: 'purchase_number' },
            { text: this.translations('payment.supplier'), value: 'kaishu_partner_name' },
            { text: this.translations('purchase.total_amount'), value: 'total_paid' },
            { text: this.translations('purchase.date_payment'), value: 'paid_at' },
            { text: this.translations('purchase.remarks'), value: 'memo' },
          ]"
          :items="payments"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(payment, i) in items" :key='i' data-href="" @click="openSinglePayments(payment)">
                  <td>{{i + 1}}</td>
                  <td>{{ payment.name }}</td>
                  <td>{{ payment.purchase_number }}</td>
                  <td>{{ payment.kaishu_partner_name }}</td>
                  <td class="right">{{ Number(payment.total_payment).toLocaleString() }}</td>
                  <td>{{ $invoiceTools.formatDate(payment.paid_at) }}</td>
                  <td>{{ payment.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <!-- <ArchivePurchasePaymentsModal /> -->
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
// import ArchivePurchasePaymentsModal from '@/components/purchase/ArchivePurchasePaymentsModal'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchivePurchasePayments',
  props: {},
  components: {
    VueElementLoading
    // ArchivePurchasePaymentsModal
  },
  data () {
    return {
      dtSearch: '',
      isSearching: false,
      partner_id: 0,
      dateFrom: '',
      dateTo: '',
      // tempDateField: '',
      payments: [],
      isEmpty: false,
      isEmptyMsg: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    partners () {
      return this.$store.getters['Master/getPayTo']
    }
  },
  watch: {
    // partner_id () {
    //   this.initList()
    // },
    page () {
      this.getFilterList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountPurchasePayments')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.$store.dispatch('Master/checkPayTo')
    const storedFilter = this.$storage.get('ArchivePurchasePaymentsParam')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.partner_id = storedFilter.partner_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    // changeSearch (e) {
    //   this.$storage.set('ArchivePurchasePayments:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterList()
      }
    },

    getFilterList (field, val) {
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.$storage.set('purchase_payments_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      const params = {
        partner_id: this.partner_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchivePurchasePaymentsParam', params)
      console.log('ArchivePurchasePayments:getFilterList: ', params)

      this.$http.post(this.$api_url.purchase_payments_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.payments = result.list
          localStorage.setItem('visitCountPurchasePayments', this.payments.length)
          this.totalCount = Number(result.total_count)
        } else {
          this.payments = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchivePurchasePayments:getFilterList:catch(error): ', error)
        this.$toastr.error(this.translations('purchase.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    openSinglePayments (payment) {
      this.$router.push({ name: 'single-purchase-payments', query: { payment_id: payment.id } })
    },

    changedPartner (event) {
      if (!event) {
        this.partner_id = 0
        return
      }
      this.partner_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    exportCsv (field, val) {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      const params = {
        partner_id: this.partner_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }

      this.$storage.set('ArchivePurchasePaymentsParam', params)
      console.log('ArchivePurchasePayments:exportCsv: ', params)

      this.$http.post(this.$api_url.purchase_payments_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.payments = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchivePurchasePayments:getFilterList:catch(error): ', error)
        this.$toastr.error(this.translations('purchase.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        data.push([
          item.name,
          item.purchase_number,
          item.kaishu_partner_name,
          item.total_payment,
          item.paid_at,
          item.memo
        ])
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('purchase.name'),
          this.translations('purchase.client_order_number'),
          this.translations('payment.supplier'),
          this.translations('purchase.total_amount'),
          this.translations('purchase.date_payment'),
          this.translations('purchase.remarks')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('payment.payment_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-payments_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
